import { default as calculationquFJPjfWdnMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailtQVqDHAWeWMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryxy4AJQilkJMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93CcFiJ0hbyGMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listfTKZhXSemGMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingFj3bVzDieWMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyouygJV0lVtwQMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellnaDEHZ9aP8Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostpFsU1CtBULMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankIJL7NsgAdUMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniN3zJOOEE47Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pagegaCQ67byhlMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testcrGrbWire6Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepageRz2V4QZ7BGMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as article39T3uHTgmzMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsxv4QgoThcIMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagbOeNOaGN5TMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorIphOKgjhXXMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categorynARwekQVAgMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionTJmICcK8s6Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesUt6QiALeLEMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryn0bXO1ehLOMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articlehtJLwHrVuPMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as section6vBGh7npv1Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactScMUDQPTuSMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationrSlBRgdS2XMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationklmvjsoxSaMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youBv4icdhGbMMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailuozUnvSpvZMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryqEdz6ow43mMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45list4HCN4COWl4Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationgRpoYjJk7QMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youanfCkYa2WQMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquirym0AFaEOkFZMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listj2bjhBShDzMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailFgWhQKuoq6Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerwhzEeEK41eMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryDNhKh3IVVjMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youxIYbUtm8iPMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationjxshrFvS1sMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listYy4ADR5moEMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youLPsV6IhghUMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineSpvNI1lzE3Meta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailWjvOXLHJEAMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneCkCuOU2jmWMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offernRVBXcrocIMeta } from "/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostpFsU1CtBULMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankIJL7NsgAdUMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniN3zJOOEE47Meta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pagegaCQ67byhlMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testcrGrbWire6Meta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepageRz2V4QZ7BGMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: article39T3uHTgmzMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsxv4QgoThcIMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagbOeNOaGN5TMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorIphOKgjhXXMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categorynARwekQVAgMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionTJmICcK8s6Meta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesUt6QiALeLEMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pagegaCQ67byhlMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryn0bXO1ehLOMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articlehtJLwHrVuPMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: section6vBGh7npv1Meta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: section6vBGh7npv1Meta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactScMUDQPTuSMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationrSlBRgdS2XMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationklmvjsoxSaMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youBv4icdhGbMMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailuozUnvSpvZMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryqEdz6ow43mMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45list4HCN4COWl4Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationgRpoYjJk7QMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youanfCkYa2WQMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquirym0AFaEOkFZMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listj2bjhBShDzMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailFgWhQKuoq6Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerwhzEeEK41eMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryDNhKh3IVVjMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youxIYbUtm8iPMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationjxshrFvS1sMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listYy4ADR5moEMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youLPsV6IhghUMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineSpvNI1lzE3Meta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailWjvOXLHJEAMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneCkCuOU2jmWMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offernRVBXcrocIMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src2413279637/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]